export default __webpack_public_path__ + "static/media/calendar-wait.25411b5d.svg";